import ContenedorTurno from '../modules/turno/components/ContenedorTurno';

const Turno = () => {
    return (
        <ContenedorTurno />
    )
}

export default Turno
